import { type SVGProps, useState } from "react";

export function ChartsIcon({ selected = false, ...props }: { selected?: boolean } & SVGProps<SVGSVGElement>) {
  const [hovered, setHovered] = useState(false);

  const modeFill = "var(--color-foreground)";
  const hoverFill = "var(--webapp-palette-primary-500)";

  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}
      className={`bottom-bar-icon ${selected ? "selected" : ""} ${props.className ?? ""}`}
      role="img"
      aria-label="Charts"
    >
      <path d="M6 6V20C6 20.5523 6.44772 21 7 21H23" stroke={modeFill} strokeWidth="2" />
      <rect
        x="21"
        y="6"
        width="2"
        height="12"
        style={{
          fill: hovered ? hoverFill : modeFill,
          transition: "fill 0.2s ease-in-out",
        }}
      />
      <rect x="18" y="11" width="2" height="7" style={{ fill: modeFill }} />
      <rect x="15" y="9" width="2" height="9" style={{ fill: modeFill }} />
      <rect x="9" y="16" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="12" y="14" width="2" height="4" style={{ fill: modeFill }} />
    </svg>
  );
}
